// extracted by mini-css-extract-plugin
export default {"treeArea":"DeviceTree_treeArea__U4vZs","searchArea":"DeviceTree_searchArea__3-pm8","darkTreeArea":"DeviceTree_darkTreeArea__EN+tp","lightTreeArea":"DeviceTree_lightTreeArea__AQIJW"};